module.exports = __webpack_public_path__ + "static/media/link-to.1e58699b.svg";